import React from 'react'
import { ZariContext } from '_zari/context'
import { Portlet, Table } from '_zari/core'
import * as SubFamiliaCrud from 'services/subFamilia.service'
import NuevaSubFamiliaModal from '../modals/nuevaSubFamiliaModal'

const portletBreadcrumbs = [{ name: 'SubFamilias' }]

const tableHeaderRows = [
  {
    label: 'NOMBRE',
    filter: {
      type: 'text',
      name: 'nom'
    }
  },
  {
    label: 'FAMILIA',
    filter: {
      type: 'text',
      name: 'nom'
    }
  },
  {
    label: ''
  }
]

const ListaSubFamiliasPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)
  const [editData, seteditData] = React.useState({ nombre: '', title: 'Nueva Sub Familia', id: '', _idFamilia: '' })
  const tablaRef = React.useRef(null)

  const [mostrarNuevaSubFamiliaModal, setMostrarNuevaSubFamiliaModal] = React.useState(false)

  const activarModal = () => setMostrarNuevaSubFamiliaModal(true)

  const clickNuevo = React.useCallback(() => {
    seteditData({ nombre: '', title: 'Nueva Sub Familia', id: '', _idFamilia: '' })
    activarModal()
  }, [])

  const clickEditar = React.useCallback(
    async ({ _id }) => {
      await SubFamiliaCrud.getSubFamilia(_id)
        .then(({ data }) => {
            
          seteditData({ nombre: data.nombre, title: 'Editar Sub Familia', id: _id, _idFamilia: data._idFamilia })
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
      activarModal()
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    async ({ _id }) => {
      await SubFamiliaCrud.eliminarSubFamilia(_id)
        .then(() => {
          __zariContext.snack('success', 'Registro eliminado')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  return (
    <>
      <>
        <Portlet>
          <Portlet.Header title='Sub Familias' breadcrumbs={portletBreadcrumbs} buttons={[{ name: 'Nuevo', onClick: clickNuevo }]} />
          <Portlet.Body>
            <Table.ServerSide
              ref={tablaRef}
              useNest={true}
              useFilters={true}
              url='/subfamilias'
              headRows={tableHeaderRows}
              rowTemplate={row => (
                <Table.Row hover key={row._id}>
                  <Table.Cell>{row.nombre || '--'}</Table.Cell>
                  <Table.Cell>{row.familia || '--'}</Table.Cell>
                  <Table.Cell>
                    <Table.Dropdown>
                      {({ handleClose }) => [
                        <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: row._id })}>
                          Editar
                        </Table.Dropdown.Item>,
                        <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _id: row._id })}>
                          Eliminar
                        </Table.Dropdown.Item>
                      ]}
                    </Table.Dropdown>
                  </Table.Cell>
                </Table.Row>
              )}
            />
          </Portlet.Body>
        </Portlet>
      </>
      {mostrarNuevaSubFamiliaModal && (
        <NuevaSubFamiliaModal
          show={mostrarNuevaSubFamiliaModal}
          handleClose={() => setMostrarNuevaSubFamiliaModal(false)}
          editData={editData}
          tablaRef={tablaRef}
        />
      )}
    </>
  )
}

export default ListaSubFamiliasPage
